module.exports = __webpack_public_path__ + "static/media/YM78_1.4b806a1b.jpg";